import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const ModalRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 664px;
  /* Grows when a long rule name wraps the title onto a second line. */
  min-height: 292px;
  padding: ${theme.spacing.large}px;
  background: ${theme.colors.surfaceContainerBackground};
  border-radius: ${theme.attributes.borderRadius.quaternary};
  box-sizing: border-box;
`

export const ModalHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding-bottom: ${theme.spacing.medium}px;

  .title {
    color: ${theme.colors.menuItemText};
    text-align: center;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: 42px;
    padding: 0 ${theme.spacing.xLarge}px;
    overflow-wrap: anywhere;
  }

  .close-button {
    position: absolute;
    top: 0;
    right: 0;

    html[data-theme='light'] & svg path {
      stroke: ${theme.colors.menuItemText};
    }
  }
`

export const ModalBody = styled(Box)`
  display: flex;
  flex-direction: column;
  padding-bottom: 48px;

  .description {
    color: ${theme.colors.devicesSecondaryText};
    text-align: center;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.25px;
    white-space: pre-line;
  }
`

export const ModalActions = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xSmall}px;

  > * {
    flex: 1;
  }

  button {
    width: 100%;
    height: 48px;
  }
`
